import { render, staticRenderFns } from "./perks.vue?vue&type=template&id=b498f762&scoped=true"
import script from "./perks.vue?vue&type=script&lang=js"
export * from "./perks.vue?vue&type=script&lang=js"
import style0 from "./perks.vue?vue&type=style&index=0&id=b498f762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b498f762",
  null
  
)

export default component.exports